<div class="section_header">
  <div class="section_header_title">
    <h2>Pedidos de apoio em eventos</h2>
  </div>
</div>

<div *ngIf="origin=='zona-stihl'" class="filters mb-4">
  <div class="row">
    <div class="col-md-3 mb-3">
      <select2 *ngIf="distributorsList.length>0" id="distribOrder" [(ngModel)]="idDistributor" [data]="distributorsList" class="select2"></select2>
    </div>
    <div class="col-md-3 mb-3">
      <select2 *ngIf="statusList.length>0" id="statusOrder" [(ngModel)]="idStatus" [data]="statusList" class="select2"></select2>
    </div>
    <div class="col-auto mb-3">
      <button class="btn-orange" (click)="rerender()">Filtrar</button>
    </div>
    <div class="col-auto mb-3">
      <button class="btn-orange-border btn-icon" (click)="downloadExcel()">
        <div class="svg-icon"><svg viewBox="0 0 150 150">
            <use xlink:href="assets/images/icons/ico_download_auto.svg#img" href="assets/images/icons/ico_download_auto.svg#img"></use>
          </svg>
        </div>
        DESCARREGAR EXCEL
      </button>
    </div>
  </div>
</div>

<div class="table-responsive-lg fadein-table">
  <table id="tblcarrusel" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table data-tables dataTable condensed-table no-footer">
    <thead>
      <tr>
        <th class="w-8 text-center">Data de pedido</th>
        <th class="w-8">Código</th>
        <th class="w-12">Concessionário</th>
        <th class="w-12">Data de inicio</th>
        <th class="w-12">Tipo Evento</th>
        <th class="w-12">Contacto</th>
        <th>E-mail</th>
        <th class="w-12">Telefone</th>
        <th *ngIf="showWoodSculpturesColumn" class="w-12">Esculturas de madeira ao vivo</th>
        <th *ngIf="showStatusColumn" class="w-12">Estado</th>
        <th class="w-8 text-center">Opções</th>
      </tr>
    </thead>
  </table>
</div>